import React from 'react'
import { ErrorPage } from './error-page'

// Граница ошибок React: ловит исключения из рендера/лайфциклов и показывает
// дружелюбный экран вместо «выкидывания» пользователя из приложения
export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { error: null }
	}

	static getDerivedStateFromError(error) {
		return { error }
	}

	componentDidCatch(error, info) {
		// Здесь можно подключить Sentry/логирование
		console.error('ErrorBoundary поймал ошибку:', error, info)
	}

	render() {
		if (this.state.error) {
			return <ErrorPage error={this.state.error} />
		}

		return this.props.children
	}
}
